// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Ltcg","text":"SelectPayment_text__1JDk2","title":"SelectPayment_title__Wbk2V","btn":"SelectPayment_btn__2iREQ"};